<template lang="pug">
  .places-list.col-12(class="md:col-8")
    .mt-16.font-bold.mb-6(class="md:mt-32") {{ result }}

    .row.lg-gutter.anim--cascad
      card(
        v-for="place in places"
        :place="place"
        :key="place.id"
        @click="openModal"
      )
        template(v-slot:placeholder="")
          slot(name="placeholder")

    place-modal(
      :place="selectedPlace"
      :translations="translations"
    )
</template>

<script>
import Card from '@components/Place/Card'
import PlaceModal from '@components/Place/Modal'

export default {
  components: {
    Card,
    PlaceModal
  },

  props: {
    places: {
      type: Array,
      required: true
    },

    translations: {
      type: Object,
      default: () => ({})
    },

    result: {
      type: String,
      default: ''
    },

    openedModalPlaceId: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      selectedPlace: {}
    }
  },

  watch: {
    places () {
      this.selectedPlace = this.places.find(place => parseInt(place.id) === this.openedModalPlaceId)
      if (this.selectedPlace) {
        this.$modal.show('place')
      }
    }
  },

  methods: {
    openModal (place) {
      this.selectedPlace = place
      this.$modal.show('place')
      const url = new URL(window.location.href)
      const modalParams = new URLSearchParams(url.search)
      modalParams.set('opened_modal_place_id', place.id)
      url.search = modalParams.toString()

      history.replaceState(null, null, url.toString())
    }
  }
}
</script>
